import axios from "axios";

export const uploadFile = async (path: string, fd: any) => {
	return await axios.post(path, fd, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
};
